<div [class.child-forms-error]="formHost.formSettings.touched && hasErrors">
<ng-content></ng-content>
</div>
